import CurrencyCircleIcon from "@shared/svg/currency-circle.svg?react";
import CustomFieldIcon from "@shared/svg/custom-field.svg?react";
import HashIcon from "@shared/svg/hash-icon.svg?react";
import CompanyIcon from "@shared/svg/navigation/companies.svg?react";
import { CalendarBlank, User } from "phosphor-react";
import React from "react";

import { OpenFolderIcon } from "~/icons/icons";

const secondary = "shrink-0 text-secondary";

const render = {
  invoiceNumber: () => (
    <HashIcon width={16} height={16} className={secondary} />
  ),
  company: () => <CompanyIcon width={16} height={16} className={secondary} />,
  status: () => (
    <CustomFieldIcon width={16} height={16} className={secondary} />
  ),
  totalAmount: () => (
    <CurrencyCircleIcon width={16} height={16} className={secondary} />
  ),
  createdBy: () => <User size={16} className={secondary} />,
  createdAt: () => <CalendarBlank size={16} className={secondary} />,
  issueDate: () => <CalendarBlank size={16} className={secondary} />,
  dueDate: () => <CalendarBlank size={16} className={secondary} />,
  workOrder: () => (
    <OpenFolderIcon
      width={16}
      height={16}
      strokeColor="#748094"
      className="shrink-0"
    />
  ),
  quote: () => <HashIcon width={16} height={16} className={secondary} />,
  calendar: () => <CalendarBlank size={16} className={secondary} />,
};

/** Shared icons for invoices table headers and column-settings dropdown. */
export const InvoiceColumnIcon = {
  invoiceNumber: render.invoiceNumber(),
  company: render.company(),
  status: render.status(),
  totalAmount: render.totalAmount(),
  createdBy: render.createdBy(),
  createdAt: render.createdAt(),
  issueDate: render.issueDate(),
  dueDate: render.dueDate(),
  workOrder: render.workOrder(),
  quote: render.quote(),
};

/** Filter dropdown expects component types (`<item.icon />`). */
export const InvoiceFilterIcon = {
  status: render.status,
  company: render.company,
  amount: render.totalAmount,
  createdBy: render.createdBy,
  calendar: render.calendar,
  workOrder: render.workOrder,
};
